import { Injectable } from '@angular/core';
import { Form, Template, Step, Question, Decision, ExecutionResult, HitConclusion, OutputData, Respondent, Section } from '../services/generated/models';
import * as _ from 'lodash';
import { forEach } from '@angular/router/src/utils/collection';


@Injectable()
export class FormService {
  currentForm: Form;
  currentTheme: Template;
  currentFormLoaded = false;
  currentThemeLoaded = false;

  public showStep(step: Step, summary: boolean): boolean {

    const that = this;
    let result = true;
    if (step !== null && step.Rules != null && step.Rules.length > 0) {
      const rule = step.Rules[0];
      if (rule.IfQuestionId > 0) {
        // find question
        const ifQuestion = that.getQuestion(rule.IfQuestionId);
        if (ifQuestion != null) {
          // check rule
          if (rule.Show) {
            if (ifQuestion.Answer != null && ifQuestion.Answer.toString() === rule.IfQuestionAnswer) {
              result = true;
            } else {
              result = false;
            }
          } else {
            if (ifQuestion.Answer != null && ifQuestion.Answer.toString() === rule.IfQuestionAnswer) {
              result = false;
            } else {
              result = true;
            }
          }
        }
      } else if (rule.IfExecutionDecisionId > 0) {
        // find decision
        const ifDecision = that.getDecisionResult(rule.IfExecutionDecisionId);
        if (ifDecision != null) {
          // check rule
          const busDataId = rule.IfExecutionIntermediateResultBusinessDataId ? rule.IfExecutionIntermediateResultBusinessDataId : +ifDecision.ViewModelFinalConclusionBusinessDataIds;
          const conclusion = that.getDecisionConclusion(ifDecision.HitConclusions, busDataId);
          if (rule.Show) {
            if (conclusion !== '' && conclusion === rule.IfExecutionResult) {
              result = true;
            } else {
              result = false;
            }
          } else {
            if (conclusion !== '' && conclusion === rule.IfExecutionResult) {
              result = false;
            } else {
              result = true;
            }
          }
        } else {
          result = !rule.Show;
        }
      }
    }

    if (summary && result) {
      let questions = step.Questions.filter(x => x.Type !== 'PercentageGauge' && x.Type !== 'InstructionTextData');
      step.Sections.forEach(s => {
        questions = questions.concat(s.Questions.filter(x => x.Type !== 'PercentageGauge' && x.Type !== 'InstructionTextData'));
      });
      result = (questions.length > 0);
    }
    return result;
  }

  public showSection(section: Section): boolean {
    const that = this;
    let nrOfQuestionsVisible = 0;
    section.Questions.forEach(question => {
      if (that.showQuestion(question)) {
        nrOfQuestionsVisible++;
      }
    });
    return (nrOfQuestionsVisible > 0);
  }

  public showQuestion(question: Question): boolean {
    const that = this;
    let result = true;
    if (question.Rules != null && question.Rules.length > 0) {
      const rule = question.Rules[0];
      if (rule.IfQuestionId > 0) {
        // find question
        const ifQuestion = that.getQuestion(rule.IfQuestionId);
        if (ifQuestion != null) {
          // check rule
          if (rule.Show) {
            if (ifQuestion.Answer != null && ifQuestion.Answer.toString() === rule.IfQuestionAnswer) {
              result = true;
            } else {
              question.Answer = null;
              result = false;
            }
          } else {
            if (ifQuestion.Answer != null && ifQuestion.Answer.toString() === rule.IfQuestionAnswer) {
              result = false;
              question.Answer = null;
            } else {
              result = true;
            }
          }
        }
      } else if (rule.IfExecutionDecisionId > 0) {
        const ifDecision = that.getDecisionResult(rule.IfExecutionDecisionId);
        // find decision
        if (ifDecision != null) {
          // check rule
          const busDataId = rule.IfExecutionIntermediateResultBusinessDataId ? rule.IfExecutionIntermediateResultBusinessDataId : +ifDecision.ViewModelFinalConclusionBusinessDataIds;
          const conclusion = that.getDecisionConclusion(ifDecision.HitConclusions, busDataId);
          if (rule.Show) {
            if (conclusion !== '' && conclusion === rule.IfExecutionResult) {
              result = true;
            } else {
              result = false;
            }
          } else {
            if (conclusion !== '' && conclusion === rule.IfExecutionResult) {
              result = false;
            } else {
              result = true;
            }
          }
        } else {
          result = !rule.Show;
        }
      }
    }
    return result;
  }

  private getQuestion(id: number): Question {
    const that = this;
    let result: Question;
    that.currentForm.Steps.forEach(step => {
      if (result == null) {
        result = step.Questions.find(q => q.Id === id);
        if (result == null) {
          step.Sections.forEach(section => {
            if (result == null) {
              result = section.Questions.find(q => q.Id === id);
            }
          })
        }
      }
    });
    return result;
  }

  private getDecisionResult(id: number): ExecutionResult {
    const that = this;
    let result: ExecutionResult;
    that.currentForm.Steps.forEach(step => {
      if (step.ExecutionResults != null && step.ExecutionResults.length > 0 && step.ExecutionResults.find(e => e.DecisionId === id) != null) {
        result = step.ExecutionResults.find(e => e.DecisionId === id);
      }
    });
    return result;
  }

  private getDecisionConclusion(hitConclusions: HitConclusion[], busDataId: number): string {
    const that = this;
    let result = '';
    if (hitConclusions == null || hitConclusions.length === 0) {
      return result;
    }
    hitConclusions.forEach(hc => {
      if (hc.BusinessDataId === busDataId) {
        result = hc.Value;
      }
    });

    return result;
  }

  public getAllQuestions(): Question[] {
    const that = this;
    let result: Question[] = [];
    that.currentForm.Steps.forEach(step => {
      if (result == null) {
        result = step.Questions;
      } else {
        result = result.concat(step.Questions);
      }
      step.Sections.forEach(section => {
        if (result == null) {
          result = section.Questions;
        } else {
          result = result.concat(section.Questions);
        }
      })
    });
    return result;
  }

  public getAllExecutionResults(): ExecutionResult[] {
    const that = this;
    let result: ExecutionResult[];
    that.currentForm.Steps.forEach(step => {
      if (result == null) {
        result = step.ExecutionResults;
      } else {
        result = result.concat(step.ExecutionResults);
      }
    })
    return result;
  }

  public getAllOutputData(): OutputData[] {
    const that = this;
    let result: OutputData[];
    that.currentForm.Steps.forEach(step => {
      step.Decisions.forEach(decision => {
        if (result == null) {
          result = decision.OutputData;
        } else {
          result = result.concat(decision.OutputData);
        }
      });
    });

    return result;
  }

  public getQuestionAnswer(question: Question): string {
    const that = this;
    if (question.Type === 'PercentageData' && question.Answer != null) {
      return that.round(+question.Answer * 100, question.DecimalPlaces) + '%';
    }
    if (question.Type === 'DateTimeData' && question.Answer != null) {
      return that.convertDateTime(question);
    }
    if (question.Type === 'CurrencyData' && question.Answer != null) {
      return question.Sign + question.Answer;
    }
    if (question.Type === 'WholeNumberData' && question.WholeNumberUnit != null) {
      return question.Answer + ' ' + question.WholeNumberUnit;
    }
    if (question.Type === 'DecimalNumberData' && question.DecimalUnit != null) {
      return question.Answer + ' ' + question.DecimalUnit;
    }
    if (question.ValueListId > 0) {
      const t = that.currentForm.Texts.find(x => x.ValueListId === question.ValueListId && x.DefaultValue === question.Answer);
      if (t) {
        return t.CustomValue;
      } else {
        return question.Answer;
      }
    } else if (question.PairId > 0) {
      const t = that.currentForm.Texts.find(x => x.PairId === question.PairId);
      if (t) {
        if (question.Answer === question.Pair.ValueForFalse) {
          return t.ValueForFalse;
        } else {
          return t.ValueForTrue;
        }
      } else {
        return question.Answer;
      }
    } else {
      return question.Answer;
    }
  }

  public getRespond(): Form {
    const that = this;

    // before passing the form, create a copy, remove check conditional behaviour / remove questions and/or steps from form if necessary
    const respondForm = _.cloneDeep(that.currentForm);
    respondForm.Steps = _.remove(respondForm.Steps, function (s) {
      return that.showStep(s, true);
    });
    respondForm.Steps.forEach(step => {
      step.Sections.forEach(section => {
        section.Questions = _.remove(section.Questions, function (q) {
          return that.showQuestion(q);
        });
        // translate
        section.Questions.forEach(q => {
          q.Answer = that.getQuestionAnswer(q);
        });
      });
      step.Questions = _.remove(step.Questions, function (q) {
        return that.showQuestion(q);
      });
      // translate
      step.Questions.forEach(q => {
        q.Answer = that.getQuestionAnswer(q);
      });
    });
    return respondForm;
  }



  public round(value, exp) {
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math.round(value);
    }
    value = +value;
    exp = +exp;

    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }
    // Shift
    value = value.toString().split('e');
    value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp)));

    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp));
  }

  public convertDateTime(question: Question): string {
    if (question.Answer == null) {
      return 'null';
    }
    if (question.DateTimePrecision === 'Days') {
      const dateTable = question.Answer.split('-');
      return dateTable[2] + '/' + dateTable[1] + '/' + dateTable[0];
    } else {
      const dateAndTimeTable = question.Answer.split(' ');
      const dateTable = dateAndTimeTable[0].split('-');
      return dateTable[2] + '/' + dateTable[1] + '/' + dateTable[0] + ' ' + dateAndTimeTable[1];
    }
  }

  public convertPercentage(question: Question): string {
    if (question.Answer == null) {
      return null;
    }
    return _.round(+question.Answer * 100, question.DecimalPlaces).toString();
  }

}




// WEBPACK FOOTER //
// D:/a/1/s/src/services/form.service.ts